declare global {
  interface Window {
    __tcFleetOauthReturn?: boolean
  }
}

const FLEET_OAUTH_STATE_PREFIX = 'ab1.'
const DIRECT_COB_PATH = '/cob/direct'
const FLEET_OAUTH_STATE_IN_QUERY = /[?&]state=ab1\./

const isDirectCobPath = (pathname: string) =>
  pathname === DIRECT_COB_PATH || pathname.startsWith(`${DIRECT_COB_PATH}/`)

export const isFleetOauthReturn = (
  pathname: string,
  search: string
): boolean => {
  if (!isDirectCobPath(pathname)) {
    return false
  }
  if (FLEET_OAUTH_STATE_IN_QUERY.test(search)) {
    return true
  }
  const state = new URLSearchParams(search).get('state')
  return state !== null && state.startsWith(FLEET_OAUTH_STATE_PREFIX)
}

export const isFleetOauthReturnWindow = (w: Window): boolean =>
  w.__tcFleetOauthReturn === true ||
  isFleetOauthReturn(w.location.pathname, w.location.search)

export const fleetOauthCallbackTarget = (
  configuredUrl: string | undefined,
  search: string,
  allowHttp: boolean = process.env.NODE_ENV !== 'production'
): string | null => {
  if (!configuredUrl) {
    return null
  }
  let parsed: URL
  try {
    parsed = new URL(configuredUrl)
  } catch {
    return null
  }
  if (
    (parsed.protocol !== 'https:' &&
      !(allowHttp && parsed.protocol === 'http:')) ||
    parsed.search ||
    parsed.hash
  ) {
    return null
  }
  return `${configuredUrl}${search}`
}
